import React from 'react'

const MobileFilterButtons = ({ children }) => {
  return (
    <div className="fixed bottom-0 fixed-center-horizontal mb-8">
      <div className="bg-white rounded rounded-full w-auto mx-auto text-center" style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)'}}>
        <div className="flex items-center justify-center">
          { children }
        </div>
      </div>
    </div>
  )
}

export { MobileFilterButtons }
